const INITIAL_STATE = {
    list: {
        status: 'loading',
        data: []
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CLUBS_LIST_STATUS':
            return {
                    ...state,
                    list: {
                        ...state.list,
                        status: action.payload
                    }
                }
        case 'CLUBS_LIST_DATA':
            return {
                    ...state,
                    list: {
                        ...state.list,
                        data: action.payload
                    }
                }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/clubsReducer.js